module.exports = __webpack_public_path__ + "img/2.109d6b92.png";